module.exports = __webpack_public_path__ + "static/media/openedLetter.acee7918.svg";